export default "__VITE_ASSET__Ba7dTuKm__"